import { useState } from "react";
import HoverableItem from "./HoverableItem";
import { useShoppingCart } from "~/utils/context/useShoppingCart";
import { MinusIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import { formatCurrency } from "~/utils/formatter/currency";

export default function Item({ item }: { item: any }) {

    const [inCart, setInCart] = useState<boolean>(false);
    const { getItemQuantity, increaseCartQuantity, decreaseCartQuantity, removeFromCart, tier, getOrderLineTotal } = useShoppingCart();
    const quantity = getItemQuantity(item.id);

    return (
        <li className="flex flex-col items-center col-span-1 cartRow h-full">
            <div className="z-10 w-full">
                {
                    item.imageBackSrc ?
                        <HoverableItem item={item} />
                        :
                        <div className="shrink-0 w-[80%] md:w-[168px] md:h-[105px] shadow-lg">
                            <img alt={item.imageAlt} src={item.imageSrc} className="w-full" />
                        </div>
                }
            </div>
            <div className="z-0 flex flex-col items-center w-full px-8 pt-16 pb-4 -mt-12 text-center bg-white border border-gray-200 shadow-md rounded-2xl h-full" >
                <p className="w-full font-semibold">{item.title}</p>
                <p className="mt-1 text-sm text-gray-500 mb-2">{item.subTitle}</p>
                <p className="mt-1 text-sm font-medium text-gray-500">{formatCurrency('USD', item.prices[tier])}</p>

                <div className="flex gap-4 pt-4 h-full">
                    {inCart || quantity > 0 ?
                        <div className="flex flex-col">
                            <div>
                                <label htmlFor="quantity" className="sr-only">
                                    Quantity
                                </label>
                                <span className="inline-flex items-center gap-4 rounded-md shadow-sm isolate">
                                    <button
                                        onClick={() => { decreaseCartQuantity(item.id) }}
                                        type="button"
                                        className="relative inline-flex items-center px-2 py-2 text-gray-400 bg-white rounded-l-md ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                                    >
                                        <span className="sr-only">Increase Quantity</span>
                                        <MinusIcon aria-hidden="true" className="size-5" />
                                    </button>
                                    {quantity}
                                    <button
                                        type="button"
                                        className="relative inline-flex items-center px-2 py-2 -ml-px text-gray-400 bg-white rounded-r-md ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                                        onClick={() => { increaseCartQuantity(item.id, item.title) }}
                                    >
                                        <span className="sr-only">Decrease Quantity</span>

                                        <PlusIcon aria-hidden="true" className="size-5" />
                                    </button>
                                </span>
                            </div>
                            <button
                                type="button"
                                className="mt-2 flex-1 flex items-center justify-center bg-white p-2.5 text-gray-400 hover:text-gray-500"
                                onClick={(e: React.MouseEvent<HTMLButtonElement>) => { e.preventDefault(); setInCart(false); removeFromCart(item.id) }}
                            >
                                <TrashIcon aria-hidden="true" className="w-5 h-5" />
                                <span className="mt-1 ml-1 text-sm">Remove</span>
                            </button>
                        </div>
                        :
                        <button
                            type="submit"
                            className="flex items-center justify-center w-full px-4 py-1 text-sm font-medium text-white border border-transparent rounded-md bg-brand-blue hover:bg-brand-blueHover focus:outline-none focus:ring-2 focus:ring-brand-blueHover focus:ring-offset-2 mt-auto"
                            onClick={(e: React.MouseEvent<HTMLButtonElement>) => { e.preventDefault(); setInCart(true); increaseCartQuantity(item.id, item.title) }}
                        >
                            Add to Cart</button>
                    }
                </div>
            </div>
        </li>
    )
};
